import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { Option } from 'components/Forms';
import { FormData, getLocalizedSchema } from 'domains/client/ProfileSelectForm/schema';
import { RadioGroup, SubmitButton } from '@expressable/syntax-ds';
import { yupResolver } from '@hookform/resolvers/yup';

type Props = {
  initialData: Partial<FormData>;
  onSubmit: SubmitHandler<FormData>;
  clientOptions: Option[];
};

export const ProfileSelectForm = ({ initialData, clientOptions, onSubmit }: Props): JSX.Element => {
  const { t } = useTranslation();

  const methods = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(getLocalizedSchema(t)),
    defaultValues: {
      clientID: initialData.clientID,
    } as FormData,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col items-start gap-e16">
        <RadioGroup name="clientID" data-testid="profileSelect">
          {clientOptions.map(option => (
            <RadioGroup.Option
              key={option.value}
              value={option.value}
              variant={'abbreviation'}
              abbreviationName={option.label as string}
              id={`clientID-${option.value}`}
            >
              {option.label as string}
            </RadioGroup.Option>
          ))}
        </RadioGroup>

        <SubmitButton size="lg" className="min-w-[200px]" fullWidth>
          {t('profileSelect.form.submitButtonText')}
        </SubmitButton>
      </form>
    </FormProvider>
  );
};
